import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { UserContext } from "../../../../Context/UserContext";
import Button from "../../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../../Reusable/BaseURL";
import MyTextarea from "../../../../Reusable/MyTextarea";
import MyInput from "../../../../Reusable/MyInput";
import { useNavigate } from "react-router-dom";
import { DirectPartySelect } from "./DirectPartySelect";
import { DirectPOCreateDivisionSelect } from "./DirectPOCreateDivisionSelect";
import { DirectPOSeveritySelect } from "./DirectPOSeveritySelect";
import { DirectPOItemByDivisionSelect } from "./DirectPOItemByDivisionSelect";
import { DirectPOBrandByItemSelect } from "./DirectPOBrandByItemSelect";
import { DirectPOUnitSelect } from "./DirectPOUnitSelect";
import DirectCreatePageForm from "./DirectCreatePageForm";
import { CustomConfirmDialog } from "../../../../Reusable/CustomConfirmDialog";
import { confirmAlert } from "react-confirm-alert";
import { DisableContext } from "../../../../Context/DisableContext";

export default function DirectPOCreate() {
  // CHANGE PO-TYPE CONFIRMATION
  // async function Check() {
  //   // await getUnsavedItemList();
  //   if (unsavedIndentItem.length > 0) {
  //     showDialog();
  //     if (unsavedIndentItem.length <= 0) {
  //       setCacheTypeFun();
  //     }
  //   }
  //   // else {
  //   // await setCacheTypeFun();
  //   // }
  // }
  // function showDialog() {
  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       return (
  //         <CustomConfirmDialog
  //           title="In Indent-PO: Your Added Items are listed !"
  //           message="If You Choose 'YES' Direct-PO-Items will be Removed. If You Choose 'NO' page will be redirect to Indent-PO-Create"
  //           onConfirm={() => {
  //             const changeConfirm = async () => {
  //               await setCacheTypeFun();
  //               await getUnsavedItemList();
  //             };
  //             changeConfirm();
  //             onClose();
  //           }}
  //           onCancel={() => {
  //             toast.success("Redirecting...Direct-PO-Create")
  //             navigate("/purchase/indent-po-create");
  //             onClose();
  //           }}
  //         />
  //       );
  //     },
  //     closeOnClickOutside: false,
  //   });
  // }
  // close check

  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
  } = useContext(UserContext);
  const { disableDirectPOCreate } = useContext(DisableContext);

  const [division, setDivision] = useState("");
  const [poPartySelect, setPOPartySelect] = useState("");
  const [date, setDate] = useState("");
  const [severity, setSeverity] = useState("Normal");
  const [remark, setRemark] = useState("");
  const [attendantName, setAttendantName] = useState("");
  const [contactNo, setContactNo] = useState("");

  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  const [qty, setQty] = useState(0);
  const [unitAmount, setUnitAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  // INITIAL PAGE LOADING
  const [initialLoading, setInitialLoading] = useState(true);
  const [timeOutLoading, setTimeOutLoading] = useState("loading");

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");
  const [myCachePartyId, setMyCachePartyId] = useState("");

  const navigate = useNavigate();

  // WITH dialogbox modal confirmation logic
  // useLayoutEffect(() => {
  //   getUnsavedCache();
  //   // initialLoadFunc();
  // }, []);

  // // CHECK PO TYPE
  // useEffect(() => {
  //   Check();
  // }, [unsavedIndentItem.length > 0]);

  // TODAY CURRENT DATE DEFAULT SET

  // useEffect(() => {
  //   const today = new Date();
  //   const formattedDate = today.toISOString().split("T")[0];
  //   setDate(formattedDate);
  //   // if(date) return postCacheItemDate();
  // setCacheTypeFun();
  //   getUnsavedItemList();
  // }, []);

  // useEffect(()=>{
  //   postCacheItemDate();
  // }, [date])

  // WITHOUT dialog confirmation logic
  async function loadDataFun() {
    await setCacheTypeFun();
    await getUnsavedItemList();
  }
  useEffect(() => {
    loadDataFun();
  }, []);

  // TYPE= "Direct" SET PO CACHE
  async function setCacheTypeFun() {
    const selectedData = { type: "Direct" };
    const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // OnBlur DATE
  async function postCacheItemDate() {
    const selectedData = { date: date };
    const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // OnBlur REMARK
  async function postCacheItemRemark() {
    const selectedData = { remarks: remark };
    const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // async function getUnsavedCache() {
  //   setInitialLoading(true);
  //   const res = await fetch(`${BaseURL}/purchase/po/getcache`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         // const cacheItems = createRes.data.items || [];
  //         const cacheItems =
  //           createRes.data !== null ? createRes.data.items : [];
  //         setUnsavedIndentItem(cacheItems);

  //         setSpinner(false);
  //       }
  //       if (createRes.status || createRes.status === false) {
  //         setInitialLoading(false);
  //         setSpinner(false);
  //       } else {
  //         setInitialLoading(false);
  //         setSpinner(false);
  //       }
  //     });
  // }
  async function getUnsavedItemList() {
    // setInitialLoading(true);
    const res = await fetch(`${BaseURL}/purchase/po/getcache`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // const cacheItems = createRes.data.items || [];
          const cacheItems =
            createRes.data !== null ? createRes.data.items : [];
          // const reverseCacheItems = cacheItems.reverse();
          // setUnsavedIndentItem(createRes.data.items || []);
          setUnsavedIndentItem(cacheItems);

          // const mygetdivision = createRes.data?.items[0];
          // const cacheDivision = mygetdivision.division;
          // setMyCacheDivision(cacheDivision || "");

          // const mygetdivision =
          //   createRes.data !== null ? createRes.data?.items[0] : {};
          // const cacheDivision = mygetdivision?.division || "";
          // setMyCacheDivision(cacheDivision || "");

          // if(createRes?.data?.items.length>0){
          const myCacheDiv = createRes?.data?.division;
          const myCacheDate = createRes?.data?.date;
          const myCacheRemark = createRes?.data?.remarks;
          const myCachePId = createRes?.data?.party_id;
          setMyCacheDivision(myCacheDiv || "");
          setMyCachePartyId(myCachePId || "");
          setDate(myCacheDate || "");
          setRemark(myCacheRemark || "");
          // }

          setSpinner(false);
          setInitialLoading(false);
        }
        if (createRes.status || createRes.status === false) {
          // setInitialLoading(false);
          setSpinner(false);
        } else {
          // setInitialLoading(false);
          setSpinner(false);
        }
      });
  }
  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  useEffect(() => {
    // getAllIndentCreated();
    // getUnsavedItemList();
  }, []);

  // ADD INDENT ITEM
  async function addIndentItem(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("item_id", item.value || "");
    // formData.append("brand_id", brand.value || "");
    // formData.append("unit_id", unit.value || "");
    // formData.append("qty", qty || "");

    const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);
    // console.log("unitRate a|fater discount", unitRateAfterDiscount.toFixed(2))

    if (division !== "") {
      setItemSubmitDisable(true);
      const formData = {
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || 0,
        party_id: poPartySelect.value || "",
        unit_rate: unitAmount || 0,
        amount: finalAmount || 0,
        discount: discount || 0,
        unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || 0,
        final_amount: netAmount || 0,
      };

      const res = await fetch(`${BaseURL}/purchase/po/setcacheitems`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            setAddMoreToggle(false);
            getUnsavedItemList();
            setItem("");
            setBrand("");
            setUnit("");
            setQty(0);

            setUnitAmount(0);
            setDiscount(0);
            setNetAmount(0);
            setFinalAmount(0);
            toast.success("Added on lists");
            setItemSubmitDisable(false);
          }
          if (createRes.status === false) {
            setItemSubmitDisable(false);
          }
          if (createRes?.error?.message.item_id) {
            toast.error(createRes.error.message.item_id);
          } else if (createRes?.error?.message.brand_id) {
            toast.error(createRes.error.message.brand_id);
          } else if (createRes?.error?.message.unit) {
            toast.error(createRes.error.message.unit);
          } else if (createRes?.error?.message.qty) {
            toast.error(createRes.error.message.qty);
          } else if (createRes?.error?.message.discount) {
            toast.error(createRes.error.message.discount);
          } else if (createRes?.error?.message) {
            toast.error("Oops! its 404");
          }
        });
    } else {
      toast.error("First Select Division.!");
      setItemSubmitDisable(false);
    }
  }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
  async function createDivision(e) {
    e.preventDefault();
    if (unsavedIndentItem.length <= 0) {
      toast.error("Please add items before submit.");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      type: "Direct",
      party_id: poPartySelect.value || "",
      date: date || "",
      severity: severity.value,
      remarks: remark,
      division: division.value,
      attendent_name: attendantName,
    };

    const res = await fetch(`${BaseURL}/purchase/po/createdirectpo`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          getUnsavedItemList();
          toast.success("Success");
          setDivision("");
          setItem("");
          setBrand("");
          setUnit("");

          setDate("");
          setSeverity("");
          setRemark("");
          setAttendantName("");

          setQty(0);

          setUnitAmount(0);
          setDiscount(0);
          setNetAmount(0);
          setFinalAmount(0);

          navigate("/purchase/pending-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.date) {
          toast.error(createRes.error.message.date);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    setEditDisable(true);
    fetch(`${BaseURL}/purchase/po/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");

          setDivision(selectedRecord.data.division || "");
          setItem(selectedRecord.data.item_name || "");
          setBrand(selectedRecord.data.brand || "");
          setUnit(selectedRecord.data.unit || "");
          setQty(selectedRecord.data.qty || 0);
          setUnitAmount(selectedRecord.data.unit_rate || 0);
          setFinalAmount(selectedRecord.data.amount || 0);
          setNetAmount(selectedRecord.data.final_amount || 0);
          setDiscount(selectedRecord.data.discount || 0);
          setEditDisable(false);
          toast.success("Go to update form");
        }
        if (selectedRecord.status === false) {
          setEditDisable(false);
        }
      });
    setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateIndentItem(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    if (division !== "") {
      const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);

      const formData = {
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || "",
        party_id: poPartySelect.value || "",
        unit_rate: unitAmount || "",
        amount: finalAmount || "",
        discount: discount || "",
        unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || "",
        final_amount: netAmount || "",
      };
      const updRes = await fetch(
        `${BaseURL}/purchase/po/updatecacheitem/${id}`,
        {
          method: "PATCH",
          body: JSON.stringify(formData),
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({name: divisionName}),
        }
      )
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            getUnsavedItemList();
            setGetId(0);
            setItem("");
            setBrand("");
            setUnit("");
            setQty(0);

            setUnitAmount(0);
            setDiscount(0);
            setNetAmount(0);
            setFinalAmount(0);

            setSubmitAction("submit");
            setAddMoreToggle(false);
            toast.success("Updated");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.amount) {
            toast.error(upd.error.message.amount);
          } else if (upd?.error?.message.brand) {
            toast.error(upd.error.message.brand);
          } else if (upd?.error?.message.unit) {
            toast.error(upd.error.message.unit);
          } else if (upd?.error?.message.qty) {
            toast.error(upd.error.message.qty);
          } else if (upd?.error?.message.final_amount) {
            toast.error(upd.error.message.final_amount);
          } else if (upd?.error?.message) {
            toast.error(upd.error.message);
          }
        });
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setItem("");
    setBrand("");
    setUnit("");
    setQty(0);

    setUnitAmount(0);
    setDiscount(0);
    setNetAmount(0);
    setFinalAmount(0);

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  function cancelPopup() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty(0);

    setUnitAmount(0);
    setDiscount(0);
    setNetAmount(0);
    setFinalAmount(0);

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
    setSubmitAction("submit");
  }

  function popupCreateIndentOnClickOut() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");
    setSubmitAction("submit");
    // setDivision("");
  }

  useEffect(() => {
    // const totalFinalAmount= (unitAmount && qty) ? (parseFloat(unitAmount) * parseFloat(qty)) : 0;
    const totalFinalAmount = parseFloat(unitAmount) * parseFloat(qty);
    const TwoDecFixed = totalFinalAmount.toFixed(2);
    // setFinalAmount(parseFloat(TwoDecFixed))
    setFinalAmount(TwoDecFixed);
  }, [unitAmount, qty]);

  // useEffect(() => {
  //   const totalFinalAmount = parseFloat(unitAmount) * parseFloat(qty);
  //   const TwoDecFixed = totalFinalAmount.toFixed(2);

  //   const totalNetAmount = TwoDecFixed - parseFloat(discount);
  //   const finalNetTwoDecFixed = totalNetAmount.toFixed(2);
  //   setNetAmount(finalNetTwoDecFixed);
  // }, [discount, qty, unitAmount]);
  useEffect(() => {
    const totalFinalAmount = parseFloat(unitAmount) * parseFloat(qty);
    const TwoDecFixed = totalFinalAmount.toFixed(2);

    const discountPercentValue =
      parseFloat(finalAmount) * (parseFloat(discount) / 100);

    // const totalNetAmount = TwoDecFixed - parseFloat(discount);
    const totalNetAmount = TwoDecFixed - parseFloat(discountPercentValue);
    const finalNetTwoDecFixed = totalNetAmount.toFixed(2);
    setNetAmount(finalNetTwoDecFixed);
  }, [discount, qty, unitAmount]);

  //  useLayoutEffect(()=>{
  //   setTimeout(()=>{
  //     setTimeOutLoading("stop")
  //   }, 4000)
  //  }, [])
  // if(timeOutLoading==="loading"){
  //   return "loading.."
  // }

  // useLayoutEffect(()=>{
  //   setTimeout(()=>{
  //     setTimeOutLoading("stop")
  //   }, 6000)
  //  }, [])

  // if(timeOutLoading==="loading"){
  //   return "loading.."
  // }

  // WITH dialog box modal confirmation loading:login
  // if(initialLoading){
  //   return "loading.."
  // }

  const gettingDiscountFunc = async (e) => {
    const { value } = e.target;
    setDiscount(value);
  };
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Direct PO Create
          </div>
          <div className="mb-2">
            <div className="grid grid-cols-1">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-2">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4 lg:grid-cols-5">
                    <div className="mb-2 w-full">
                      <label>
                        Division{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <DirectPOCreateDivisionSelect
                        selectedOption={division}
                        setSelectedOption={setDivision}
                        changingSelect={changingSelect}
                        setEmpty={setItem}
                        addMoreToggle={addMoreToggle}
                        unsavedIndentItem={unsavedIndentItem}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                        myCacheDivision={myCacheDivision}
                        getUnsavedItemList={getUnsavedItemList}
                        setBrand={setBrand}
                        setItem={setItem}
                        setUnit={setUnit}
                        setQty={setQty}
                        setInitialLoading={setInitialLoading}
                      />
                    </div>
                    <div className="mb-2 w-full">
                      <label>
                        Party <span className="text-red-500 font-bold">*</span>
                      </label>
                      <DirectPartySelect
                        selectedOption={poPartySelect}
                        setSelectedOption={setPOPartySelect}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                        // setEmpty={setItem}
                        // addMoreToggle={addMoreToggle}
                        unsavedIndentItem={unsavedIndentItem}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                        getUnsavedItemList={getUnsavedItemList}
                        myCachePartyId={myCachePartyId}
                        setBrand={setBrand}
                        setItem={setItem}
                        setUnit={setUnit}
                        setQty={setQty}
                        setInitialLoading={setInitialLoading}
                      />
                    </div>

                    <div className="mb-2 w-full">
                      <label>
                        Severity{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <DirectPOSeveritySelect
                        selectedOption={severity}
                        setSelectedOption={setSeverity}
                      />
                    </div>
                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onBlur={() => postCacheItemRemark()}
                    />
                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Date <span className="text-red-500 font-bold">*</span>
                      </label>
                      <input
                        onBlur={() => postCacheItemDate()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>

                    <MyTextarea
                      label="Attendant Name"
                      type="text"
                      className="w-full"
                      value={attendantName}
                      onChange={(e) => setAttendantName(e.target.value)}
                    />
                    <MyTextarea
                      label="Contact No"
                      type="number"
                      className="w-full"
                      value={contactNo}
                      onChange={(e) => setContactNo(e.target.value)}
                    />
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}

              {/* RIGHT PART  */}
              <div className="bg-[#8CDDCD] rounded-xl p-3">
                <div className="mb-2 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-2">
                  <div className="mb-2">
                    <label>
                      Item <span className="text-red-500 font-bold">*</span>{" "}
                      <span className="text-[12px]">
                        {item ? `HSNno. ${item.hsn_no}` : ""}
                      </span>
                    </label>
                    <DirectPOItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  {/* <div className="mb-2">
                    <label>
                      Item Code{" "}
                      <span className="text-red-500 font-bold">*</span>
                    </label>
                    <ItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                    />
                  </div> */}
                  <div className="mb-2">
                    <label>
                      Brand <span className="text-red-500 font-bold">*</span>
                    </label>
                    <DirectPOBrandByItemSelect
                      itemItemId={item && item.value}
                      selectedOption={brand}
                      setSelectedOption={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>

                  <div className="mb-2">
                    <label>
                      Unit <span className="text-red-500 font-bold">*</span>
                    </label>
                    <DirectPOUnitSelect
                      selectedOption={unit}
                      setSelectedOption={setUnit}
                      unitByItem={item}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <MyInput
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    label="Quantity"
                    className="w-full"
                    mendatory="*"
                    type="number"
                  />
                  <MyInput
                    value={unitAmount}
                    onChange={(e) => setUnitAmount(e.target.value)}
                    label="Unit Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                  <MyInput
                    value={finalAmount}
                    onChange={(e) => setFinalAmount(e.target.value)}
                    label="Final Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                    readOnly
                  />
                  <MyInput
                    value={discount}
                    // onChange={(e) => setDiscount(e.target.value)}
                    onChange={(e) => gettingDiscountFunc(e)}
                    label="Discount %"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                  <MyInput
                    value={netAmount}
                    onChange={(e) => setNetAmount(e.target.value)}
                    label="Net Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                    readOnly
                  />
                </div>
                <div className="flex items-center justify-center gap-1">
                  {submitAction === "submit" && (
                    <Button
                      disabled={itemSubmitDisable}
                      type="submit"
                      onClick={(e) => addIndentItem(e)}
                      className="!bg-yellow-600"
                    >
                      {itemSubmitDisable ? "Wait.." : "Add Item"}
                    </Button>
                  )}
                  {submitAction !== "submit" && (
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateIndentItem(e, getId)}
                      className="!bg-yellow-600"
                    >
                      {updateDisable ? "Wait.." : "Update Item"}
                    </Button>
                  )}
                  <Button
                    onClick={() => cancelPopup()}
                    className="!bg-gray-200 !text-black"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              {/* END RIGHT PART  */}
            </div>
          </div>

          {/* ITEM LIST FORM  */}
          <div className="w-full px-2 mb-4">
            <DirectCreatePageForm
              editBtn={editBtn}
              firstPageList={getUnsavedItemList}
              links={links}
              firstPage={unsavedIndentItem}
              setGetId={setGetId}
              spinner={spinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
              editDisable={editDisable}
              initialLoading={initialLoading}
            />
          </div>

          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                disabled={submitDisable}
                onClick={(e) => createDivision(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}

          {/* PAGE DISABLE  */}
          {disableDirectPOCreate && (
            <div className="fixed top-0 left-0 right-0 bottom-0 z-[8000] bg-white h-full flex items-center justify-center">
              Fetching..
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
